<script>
import confirmationResendButtonJson from '@/data/json/profile/confirmationResendButton.json'

export default {
  props: {
    email: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: null
    }
  },
  data: () => ({
    content: confirmationResendButtonJson.data,
    dialog: false,
    loading: false,
    status: ''
  }),
  computed: {
    contentText() {
      return contentKey =>
        this.$cms.get(
          this.content,
          contentKey + (this.status ? '_' + this.status : '')
        )
    }
  },
  created: function() {
    // argument is cms api-endpoint
    this.$cmsService
      .fetchContent('confirmationResendcontents')
      .then(response => {
        if (response !== '') this.content = response
      })
      .catch(() => {})
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.$emit('closed')
    },
    resendEmail() {
      this.loading = true
      this.$userService
        .sendConfirmationEmail({
          email: this.email,
          confirmationURL: `${window.config.VUE_APP_BASE_URL}/registrationconfirmation`
        })
        .then(() => {
          this.status = ''
        })
        .catch(() => {
          this.status = 'failed'
        })
        .finally(() => {
          this.dialog = true
          this.loading = false
          this.$emit('click')
        })
    }
  }
}
</script>
<template>
  <div>
    <v-card-actions class="justify-center">
      <v-btn
        :loading="loading"
        class="text-center px-8 cms_register wordBreak"
        color="primary"
        depressed
        @click.stop="resendEmail"
      ><slot name="buttonText">{{
          $cms.get(content, 'resend_confirmation_email')
        }}</slot></v-btn
      >
    </v-card-actions>
    <v-dialog v-model="dialog" max-width="500" @click:outside="closeDialog">
      <v-card class="pa-6">
        <v-icon class="float-right" color="primary" medium @click="closeDialog"
        >mdi-close</v-icon
        >
        <v-card-title class="justify-center">
          <h2
            class="headline text--primary-2"
            :class="[status === 'failed' ? 'error--text' : 'primary--text']"
          >
            <span>{{ contentText('confirmation_header') }}</span>
          </h2>
        </v-card-title>
        <v-card-text
          class="pt-8 pb-8 float-center"
          v-html="contentText('confirmation_message')"
        >
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="grey"
            class="white--text text-capitalize px-8 py-2"
            @click="closeDialog"
          ><span>{{
              $cms.get(content, 'confirmation_button_label')
            }}</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
